import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import { FraudRoutePoint } from '../../fraud-case-details.models';
import { buildRouteSegments } from '../../fraud-case-details.utils';

@Component({
  selector: 'app-fraud-case-routes',
  templateUrl: './fraud-case-routes.component.html',
  styleUrls: ['../fraud-case-card.css', './fraud-case-routes.component.css']
})
export class FraudCaseRoutesComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() firstUnitId = '';
  @Input() secondUnitId = '';
  @Input() points: FraudRoutePoint[] | null = null;
  @Input() loading = false;
  @Input() error = '';
  @Output() loadRequested = new EventEmitter<void>();
  @ViewChild('mapTarget', { static: true }) mapTarget!: ElementRef<HTMLDivElement>;
  routeCounts: number[] | null = null;
  mapError = '';
  private map?: L.Map;
  private routeLayer?: L.FeatureGroup;

  ngAfterViewInit(): void {
    if (this.points !== null) this.renderRoutes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['points'] && !changes['firstUnitId'] && !changes['secondUnitId']) return;
    this.routeCounts = null;
    this.mapError = '';
    this.routeLayer?.clearLayers();
    if (this.points !== null && this.mapTarget) this.renderRoutes();
  }

  ngOnDestroy(): void {
    this.map?.remove();
  }

  private renderRoutes(): void {
    try {
      this.drawRoutes(this.points || []);
    } catch {
      this.mapError = 'دریافت یا نمایش مسیر با خطا مواجه شد. دوباره تلاش کنید.';
    }
  }

  private drawRoutes(points: FraudRoutePoint[]): void {
    if (!this.mapTarget) return;
    if (!this.map) {
      this.map = L.map(this.mapTarget.nativeElement).setView([35.75, 51.3], 11);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19, attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);
      this.routeLayer = L.featureGroup().addTo(this.map);
    }
    this.routeLayer!.clearLayers();
    const counts: number[] = [];
    [this.firstUnitId, this.secondUnitId].forEach((id, index) => {
      const segments = buildRouteSegments(points.filter(point => String(point.strUnitID) === String(id)));
      counts.push(segments.reduce((count, segment) => count + segment.length, 0));
      const color = ['#2563eb', '#ef4444'][index];
      segments.forEach(segment => {
        const coords = segment.map(point => L.latLng(Number(point.dLatitude), Number(point.dLongitude)));
        const layer = coords.length > 1 ? L.polyline(coords, { color, weight: 5, opacity: 0.85 }) : L.circleMarker(coords[0], { color, radius: 4 });
        this.routeLayer!.addLayer(layer);
      });
      if (!segments.length) return;
      const last = segments[segments.length - 1];
      [segments[0][0], last[last.length - 1]].forEach((point, endpoint) => {
        const text = document.createElement('span');
        text.textContent = `${endpoint ? 'پایان' : 'شروع'} خودروی ${index ? 'دوم' : 'اول'}`;
        L.circleMarker([Number(point.dLatitude), Number(point.dLongitude)], { color, fillColor: color, fillOpacity: 1, radius: 6 })
          .bindTooltip(text).addTo(this.routeLayer!);
      });
    });
    this.map.invalidateSize();
    const bounds = this.routeLayer!.getBounds();
    if (bounds.isValid()) this.map.fitBounds(bounds, { padding: [25, 25], maxZoom: 16 });
    this.routeCounts = counts;
  }
}
